module.exports = __webpack_public_path__ + "static/leaf-3-643441cfa1642cbb109f644e590ce71f.png";